// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import {Button, Input} from "antd";
import React from "react";
import i18next from "i18next";
import * as AuthBackend from "./AuthBackend";
import * as Setting from "../Setting";

const {Search} = Input;

export const Oauth2PhoneSendCodeInput = ({value, disabled, onChange, phone, oauthBody, onSendCode}) => {
  const [buttonLeftTime, setButtonLeftTime] = React.useState(0);
  const [buttonLoading, setButtonLoading] = React.useState(false);

  const handleCountDown = (leftTime = 60) => {
    let leftTimeSecond = leftTime;
    setButtonLeftTime(leftTimeSecond);
    const countDown = () => {
      leftTimeSecond--;
      setButtonLeftTime(leftTimeSecond);
      if (leftTimeSecond === 0) {
        return;
      }
      setTimeout(countDown, 1000);
    };
    setTimeout(countDown, 1000);
  };

  const handleSendCode = () => {
    console.log('oauthBody', oauthBody);
    console.log('phone', phone);
    if (!phone || !oauthBody) {
      return;
    }
    onSendCode?.();

    setButtonLoading(true);
    const body = {
      application: oauthBody.application || "",
      provider: oauthBody.provider || "",
      redirectUri: oauthBody.redirectUri || "",
      code: oauthBody.code || "",
      state: oauthBody.state || "",
      phone: phone,
    };

    AuthBackend.sendOauth2UserPhoneVerificationCode(body)
      .then((res) => {
        setButtonLoading(false);
        if (res.status === "ok") {
          Setting.showMessage("success", i18next.t("user:Verification code sent"));
          handleCountDown(60);
        } else {
          Setting.showMessage("error", res.msg);
        }
      })
      .catch(() => {
        setButtonLoading(false);
        Setting.showMessage("error", i18next.t("general:Failed to connect to server"));
      });
  };

  return (
    <Search
      className="custom-search"
      disabled={disabled}
      value={value}
      placeholder={i18next.t("code:Enter your code")}
      onChange={e => onChange(e.target.value)}
      enterButton={
        <Button style={{fontSize: 14}} type={"primary"} disabled={disabled || buttonLeftTime > 0} loading={buttonLoading}>
          {buttonLeftTime > 0 ? i18next.t("code:Re-acquire", {time: buttonLeftTime}) : buttonLoading ? i18next.t("code:Sending") : i18next.t("code:Send Code")}
        </Button>
      }
      onSearch={handleSendCode}
      autoComplete="one-time-code"
    />
  );
};
